/**
 * Takes a string and capitalizes the first letter only
 */
const capitalize = str => {
  // If string is an object charAt won't work so return obj
  if (str.charAt) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str;
  }
};

export default capitalize;
